.wrapper {
  display: flex;
  flex-direction: column;
  gap: var(--spacingLg);
}

.column {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (max-width: 800px) {
    width: 100%;
  }
}

.datesContainer {
  display: flex;
  justify-content: space-between;
  gap: var(--spacingMd);
  width: 100%;
}

.calendar {
  > * {
    width: inherit;
  }
}

.line {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  margin-top: 10px;
}

.addNewBookingIcon {
  margin-left: 10px;
}
